<template>
  <div>
    <div
      v-for="media in mediasList"
      :key="media.value"
      class="video-container"
    >
      <iframe
        v-if="media.type === 'http'"
        :src="media.value"
        frameborder="0"
        allowfullscreen
        width="853"
        height="480"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  medias: Array<any>
}>()

const mediasList = computed(() => {
  return [...props.medias].reverse().map(function (media) {
    return {
      ...media,
      value: media.value.replace('https://youtu.be', 'https://www.youtube.com/embed')
    }
  })
})
</script>

<style scoped>
iframe {
  width: 100%;
}

@media (width <= 768px) {
  .video-container {
    position: relative;
    height: 245px;
    margin-left: -15px;
    margin-right: -15px;
  }

  iframe {
    height: 245px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
}

.video-container {
  margin-bottom: 30px;
}
</style>
